/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Success_TitleInputs */

const en_directory_submit_success_title = /** @type {(inputs: Directory_Submit_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you!`)
};

const zh_directory_submit_success_title = /** @type {(inputs: Directory_Submit_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交成功！`)
};

/**
* | output |
* | --- |
* | "Thank you!" |
*
* @param {Directory_Submit_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_success_title = /** @type {((inputs?: Directory_Submit_Success_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Success_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_success_title(inputs)
	return zh_directory_submit_success_title(inputs)
});
export { directory_submit_success_title as "directory.submit.success_title" }